import axios from "axios";
import { API_URL_RESTAURANT_ADD_ABSENCES, API_URL_RESTAURANT_ADD_EMPLOYEE, API_URL_RESTAURANT_ADD_LEAVEDAYS_FOR_EMPLOYEE, API_URL_RESTAURANT_ASSIGN_FORMATIONS, API_URL_RESTAURANT_DELETE_DAILY_RESULTS, API_URL_RESTAURANT_DELETE_EMPLOYEEs, API_URL_RESTAURANT_ARCHIVE_EMPLOYEES, API_URL_RESTAURANT_ACTIVATE_EMPLOYEES,API_URL_RESTAURANT_DELETE_FORMATIONS, API_URL_RESTAURANT_DELETE_PLANNING_CHANGES, API_URL_RESTAURANT_DELETE_WEEKLY_PLANNING_FORECAST, API_URL_RESTAURANT_DOWNLOAD_PLANNING, API_URL_RESTAURANT_EDIT_EMPLOYEE, API_URL_RESTAURANT_GENERATE_PLANNING, API_URL_RESTAURANT_GET_EMPLOYEE_WEEKLY_AVAILABILITIES, API_URL_RESTAURANT_GET_EMPLOYEES, API_URL_RESTAURANT_GET_EMPLOYEES_WITH_FORMATIONS, API_URL_RESTAURANT_GET_EMPLOYEES_WITH_FORMATIONS_AND_AVAILABILITIES, API_URL_RESTAURANT_GET_FORMATIONS, API_URL_RESTAURANT_GET_LEAVEDAYS_OF_EMPLOYEE, API_URL_RESTAURANT_GET_PLANNING, API_URL_RESTAURANT_GET_WEEKLY_PLANNING_FORECASTS, API_URL_RESTAURANT_REGENERATE_WEEKLY_PLANNING_FORECASTS, API_URL_RESTAURANT_REMOVE_LEAVEDAYS_FOR_EMPLOYEE, API_URL_RESTAURANT_SAVE_PLANNING_CHANGES, API_URL_RESTAURANT_TODAYS_DATA, API_URL_RESTAURANT_TODAYS_FORECAST, API_URL_RESTAURANT_UPSERT_WEEKLY_PLANNING_FORECASTS, API_URL_RESTAURANT_EMPLOYEE_NOT_WORKINGS, API_URL_RESTAURANT_ADD_WORK_DAYS_FOR_EMPLOYEES, API_URL_RESTAURANT_UPSERT_FORMATION, API_URL_RESTAURANT_DELETE_PLANNING_WEEK, API_URL_RESTAURANT_DELETE_PLANNING_FORECAST_WEEK, API_URL_RESTAURANT_DELETE_PARAMETRES, API_URL_RESTAURANT_GET_PARAMETRES, API_URL_RESTAURANT_UPSERT_PARAMETRES } from "./Routes";
import Employee from "../types/api/Employee";
import Formation from "../types/api/Formation";
import WeeklyPlanning from "../types/api/WeeklyPlanning";
import EmployeeWorkWeek from "../types/api/WorkWeek";
import EmployeeWorkDay from "../types/api/WorkDay";
import LeaveDay from "../types/api/LeaveDays";
import TodaysStats from "../types/api/TodaysStats";
import DailyResult from "../types/api/DailyResult";
import WeeklyAvailability from "../types/api/WeeklyAvailability";
import LocalWorkdayChange from "../types/api/LocalWorkdayChanges";
import { WeeklyShiftForecast } from "../types/api/WeeklyShiftForecast";
import { DailyClientForecast } from "../types/api/DailyClientForecast";
import { RegenerateForecastOption } from "../types/api/RegenerateForecastOption";
import Parametres from "../types/api/Parametres";

export async function addEmployee(Employee: Employee) {
    try {
        const res = await axios.post(API_URL_RESTAURANT_ADD_EMPLOYEE, {
            employee: {
                ...Employee
            }
        },
        { withCredentials: true }
        )
        return res.data as ApiResponse<{id: number}>;
    } catch (error) {
        console.error(error)
        return false
    }
}

export async function editEmployee(Employee: Employee) {
    console.log('[editEmployee] called with:', Employee);
    console.log('API_URL_RESTAURANT_EDIT_EMPLOYEE =', API_URL_RESTAURANT_EDIT_EMPLOYEE);
    try {
        const res = await axios.post(API_URL_RESTAURANT_EDIT_EMPLOYEE, {
            employee: {
                ...Employee
            }
        },
        { withCredentials: true }
        )
        console.log('[editEmployee] axios response:', res);
        return res.data as ApiResponse<{id: number}>;
    } catch (error) {
        console.error('[editEmployee] error:', error)
        return false
    }
}

export async function deleteEmployees(Employees: number[]) {
    try {
        const res = await axios.post(API_URL_RESTAURANT_DELETE_EMPLOYEEs, {
            employees: Employees
        },
        { withCredentials: true }
        )
        return res.data as ApiResponse<null>;
    } catch (error) {
        console.error(error)
        return false
    }
}

export async function archiveEmployees(Employee: Employee) {
    try {
        const res = await axios.post(API_URL_RESTAURANT_ARCHIVE_EMPLOYEES, {
            employee: {...Employee},
            isActive: false
        },
        { withCredentials: true }
        )
        return res.data as ApiResponse<null>;
    } catch (error) {
        console.error(error)
        return false
    }
}

export async function activeEmployees(Employee: Employee) {
    try {
        const res = await axios.post(API_URL_RESTAURANT_ACTIVATE_EMPLOYEES, {
            employee: {...Employee},
            isActive: true
        },
        { withCredentials: true }
        )
        return res.data as ApiResponse<null>;
    } catch (error) {
        console.error(error)
        return false
    }
}

export async function listEmployees() {
    try {
        const res = await axios.get(API_URL_RESTAURANT_GET_EMPLOYEES, { withCredentials: true });

        (res.data.data as Employee[]).forEach((Employee: Employee) => {
            Employee.entryDate = new Date(Employee.entryDate)
            Employee.visaExpirationDate = Employee.visaExpirationDate ? new Date(Employee.visaExpirationDate) : null
        })
        return res.data as ApiResponse<Employee[]>;
    } catch (error) {
        console.error(error)
        return error as ApiResponse<null>
    }
}

export async function listEmployeesWithFormations() {
    try {
        const res = await axios.get(API_URL_RESTAURANT_GET_EMPLOYEES_WITH_FORMATIONS, { withCredentials: true });

        (res.data.data as Employee[]).forEach((Employee: Employee) => {
            Employee.entryDate = new Date(Employee.entryDate)
            Employee.visaExpirationDate = Employee.visaExpirationDate ? new Date(Employee.visaExpirationDate) : null
        })
        return res.data as ApiResponse<Employee[]>;
    } catch (error) {
        console.error(error)
        return false
    }
}

export async function listEmployeesWithFormationsAndAvailabilities() {
    try {
        const res = await axios.get(API_URL_RESTAURANT_GET_EMPLOYEES_WITH_FORMATIONS_AND_AVAILABILITIES, { withCredentials: true });

        (res.data.data as Employee[]).forEach((Employee: Employee) => {
            Employee.entryDate = new Date(Employee.entryDate)
            Employee.visaExpirationDate = Employee.visaExpirationDate ? new Date(Employee.visaExpirationDate) : null
        })
        return res.data as ApiResponse<Employee[]>;
    } catch (error) {
        console.error(error)
        return false
    }
}

export async function upsertFormation(Formation: Formation) {
    try {
        const res = await axios.post(
            API_URL_RESTAURANT_UPSERT_FORMATION,
            {
                formation: {
                    id: Formation.id,
                    label: Formation.label,
                    ratio: Formation.ratio,
                    color: Formation.color,
                    bottomCap: Formation.bottomCap,
                    minimumShifts: Formation.minimumShifts,
                    maximumShifts: Formation.maximumShifts,
                    autoStaffing: Formation.autoStaffing,
                    groupingId: Formation.groupingId,
                    groupingPriority: Formation.groupingPriority
                }
            },
            { withCredentials: true });

        return res.data as ApiResponse<{id: number}>;
    } catch(error){
        console.error(error)
        return false
    }
}

export async function deleteFormations(Formations: number[]) {
    try {
        const res = await axios.post(API_URL_RESTAURANT_DELETE_FORMATIONS, {
            formation: Formations
        },
        { withCredentials: true }
        )
        return res.data as ApiResponse<null>;
    } catch (error) {
        console.error(error)
        return false
    }
}

export async function updateFormationsOfEmployee(EmployeeId: number, Formations: Formation[]) {
    try {
        const res = await axios.post(API_URL_RESTAURANT_ASSIGN_FORMATIONS, {
            employee: {
                id: EmployeeId
            },
            formation: Formations.map((form)=>form.id)
        },
        { withCredentials: true }
        )
        return res.data as ApiResponse<null>;
    } catch (error) {
        console.error(error)
        return false
    }
}

export async function listFormations() {
    try {
        const res = await axios.get(API_URL_RESTAURANT_GET_FORMATIONS, { withCredentials: true });

        return res.data as ApiResponse<Formation[]>;
    } catch (error) {
        console.error(error)
        return false
    }
}

export async function listPlanning(weekNumber: number, year: number) {
    try {
        const res = await axios.post(API_URL_RESTAURANT_GET_PLANNING, {weekNumber: weekNumber, year: year}, { withCredentials: true });
        (res.data.data as WeeklyPlanning).EmployeeWorkWeeks.forEach((Employee: EmployeeWorkWeek) => {
            Employee.entryDate = new Date(Employee.entryDate)
        })
        return res.data as ApiResponse<WeeklyPlanning>;
    } catch (error) {
        console.error(error)
        return error as ApiResponse<null>
    }
}

export async function generatePlanning(getWeekNumber: number, year: number) {
    console.log('generatePlanning called with:', getWeekNumber, year);
    try {
        const res = await axios.post(API_URL_RESTAURANT_GENERATE_PLANNING,
            { weekNumber: getWeekNumber, year: year },
            { withCredentials: true }
        );

        return res.data as ApiResponse<WeeklyPlanning>;
    } catch (error) {
        console.error(error)
        return error as ApiResponse<null>
    }
}

export async function downloadPlanning(getWeekNumber: number, year: number) {
    console.log('downloadPlanning called with:', getWeekNumber, year);
    try {
        const res = await axios.post(API_URL_RESTAURANT_DOWNLOAD_PLANNING,
            {weekNumber: getWeekNumber, year: year},
            { withCredentials: true }
        );

        return res.data as ApiResponse<{
            file: {
                type: string,
                data: Buffer
            }
        }>;
    } catch (error) {
        console.error(error)
        return error as ApiResponse<null>
    }
}

export async function getDashboardInfos() {
    try {
        // On utilise maintenant la route /api/performance/todaysStats pour les prévisions
        const res = await axios.get(API_URL_RESTAURANT_TODAYS_FORECAST, { withCredentials: true });
        return res.data as ApiResponse<TodaysStats>;
    } catch (error) {
        console.error(error)
        return error as ApiResponse<null>
    }
}

export async function addAbsences(workDays: EmployeeWorkDay[]) {
    try {
        const res = await axios.post(API_URL_RESTAURANT_ADD_ABSENCES, {absences: workDays}, { withCredentials: true });

        return res.data as ApiResponse<null>;
    } catch (error) {
        console.error(error)
        return error as ApiResponse<null>
    }
}

export async function getLeaveDaysOfEmployee(employee: Employee) {
    try {
        const res = await axios.post(API_URL_RESTAURANT_GET_LEAVEDAYS_OF_EMPLOYEE, {id: employee.id}, { withCredentials: true });

        return res.data as ApiResponse<LeaveDay[]>;
    } catch (error) {
        console.error(error)
        return error as ApiResponse<null>
    }
}

export async function addLeaveDays(leaveDays: LeaveDay[]) {
    try {
        const res = await axios.post(API_URL_RESTAURANT_ADD_LEAVEDAYS_FOR_EMPLOYEE, {leaveDays: leaveDays}, { withCredentials: true });

        return res.data as ApiResponse<LeaveDay[]>;
    } catch (error) {
        console.error(error)
        return error as ApiResponse<null>
    }
}

export async function removeLeaveDays(leaveDays: LeaveDay[]) {
    try {
        const res = await axios.post(API_URL_RESTAURANT_REMOVE_LEAVEDAYS_FOR_EMPLOYEE, {leaveDays: leaveDays}, { withCredentials: true });

        return res.data as ApiResponse<LeaveDay[]>;
    } catch (error) {
        console.error(error)
        return error as ApiResponse<null>
    }
}

export async function deleteDailyResults(result: DailyResult) {
    try {
        const res = await axios.post(API_URL_RESTAURANT_DELETE_DAILY_RESULTS, {dailyResult: result}, { withCredentials: true });

        return res.data as ApiResponse<null>;
    } catch (error) {
        console.error(error)
        return error as ApiResponse<null>
    }
}

export async function getTodaysStats() {
    try {
        const res = await axios.get(API_URL_RESTAURANT_TODAYS_DATA, { withCredentials: true });

        return res.data as ApiResponse<TodaysStats>;
    } catch (error) {
        console.error(error)
        return error as ApiResponse<null>
    }
}

export async function getTodaysForecastStats() {
    try {
        const res = await axios.get(API_URL_RESTAURANT_TODAYS_FORECAST, { withCredentials: true });
        return res.data as ApiResponse<TodaysStats>;
    } catch (error) {
        console.error(error)
        return error as ApiResponse<null>
    }
}

export async function listeEmployeeAvailabilities(employeeId: number) {
    try {
        const res = await axios.post(API_URL_RESTAURANT_GET_EMPLOYEE_WEEKLY_AVAILABILITIES, {employeeId: employeeId}, { withCredentials: true });

        return res.data as ApiResponse<WeeklyAvailability[]>;
    } catch (error) {
        console.error(error)
        return false
    }
}

export async function savePlanningChanges(changes: LocalWorkdayChange[]) {
    try {
        const res = await axios.post(API_URL_RESTAURANT_SAVE_PLANNING_CHANGES, {changes: changes}, { withCredentials: true });

        return res.data as ApiResponse<WeeklyAvailability[]>;
    } catch (error) {
        console.error(error)
        return false
    }
}

export async function deletePlanningChanges(){
    try {
        const res = await axios.post(API_URL_RESTAURANT_DELETE_PLANNING_CHANGES, { withCredentials: true });

        return res.data as ApiResponse<WeeklyAvailability[]>;
    } catch (error) {
        console.error(error)
        return false
    }
}

/**
 * Params can be null to allow fetching regular stored shifts
 * @param year 
 * @param weekNumber 
 * @returns 
 */
export async function getWeeklyPlanningForecasts(year: number | null, weekNumber: number | null) {
    try {
        const res = await axios.get(API_URL_RESTAURANT_GET_WEEKLY_PLANNING_FORECASTS, {
            params: { year, weekNumber },
            withCredentials: true
        });
        return res.data as ApiResponse<{
            clientForecasts: DailyClientForecast[],
            forecasts: WeeklyShiftForecast[]
        }>;
    } catch (error) {
        console.error(error)
        return false
    }
}

export async function upsertWeeklyPlanningForecast(shift: WeeklyShiftForecast) {
    const formattedShift = {
        ...shift,
        preassignedEmployees: shift.preassignedEmployees.map(emp => ({id: emp.id}))
    }
    try {
        const res = await axios.post(API_URL_RESTAURANT_UPSERT_WEEKLY_PLANNING_FORECASTS, formattedShift, { withCredentials: true });
        return res.data as ApiResponse<null>;
    } catch (error) {
        console.error(error)
        return false
    }
}

export async function deleteWeeklyPlanningForecast(id: number) {
    try {
        const res = await axios.delete(`${API_URL_RESTAURANT_DELETE_WEEKLY_PLANNING_FORECAST}/${id}`, {
            withCredentials: true
        });
        return res.data as ApiResponse<{ id: number }>;
    } catch (error) {
        console.error(error)
        return false
    }
}


export async function regenerateWeeklyShiftsForecasts(year: number, weekNumber: number, regenerateForecastOptions: RegenerateForecastOption) {
    try {
        const res = await axios.get(API_URL_RESTAURANT_REGENERATE_WEEKLY_PLANNING_FORECASTS, {
            params: { year, weekNumber, regenerateForecastOptions: JSON.stringify(regenerateForecastOptions) },
            withCredentials: true
        });
        return res.data as ApiResponse<null>;
    } catch (error) {
        console.error(error)
        return false
    }
}

export async function listEmployeesNotWorking(year: number, weekNumber: number) {
    try {
        const res = await axios.get(API_URL_RESTAURANT_EMPLOYEE_NOT_WORKINGS, {
            params: { year, weekNumber },
            withCredentials: true
        });
        return res.data as ApiResponse<Employee[]>;
    } catch (error) {
        console.error(error)
        return false
    }
}

export async function addEmptyWorkWeekForEmployees(year: number, weekNumber: number, employeeIds: number[]) {
    try {
        const res = await axios.post(API_URL_RESTAURANT_ADD_WORK_DAYS_FOR_EMPLOYEES,
            { year, weekNumber, employeeIds },
            { withCredentials: true}
        );
        return res.data as ApiResponse<Employee[]>;
    } catch (error) {
        console.error(error)
        return false
    }
}

export async function deletePlanningWeek(year: number, weekNumber: number) {
    try {
        const res = await axios.post(API_URL_RESTAURANT_DELETE_PLANNING_WEEK,
            { year, weekNumber },
            { withCredentials: true}
        );
        return res.data as ApiResponse<null>;
    } catch (error) {
        console.error(error)
        return false
    }
}

export async function deletePlanningForecastWeek(year: number, weekNumber: number) {
    try {
        const res = await axios.post(API_URL_RESTAURANT_DELETE_PLANNING_FORECAST_WEEK,
            { year, weekNumber },
            { withCredentials: true}
        );
        return res.data as ApiResponse<null>;
    } catch (error) {
        console.error(error)
        return false
    }
}


export async function deleteParametres(id: number) {
    try {
        const res = await axios.post(API_URL_RESTAURANT_DELETE_PARAMETRES,
            { withCredentials: true},
            { params: { id } }
        );
        return res.data as ApiResponse<null>;
    } catch (error) {
        console.error(error)
        return false
    }
}

export async function listParametres() {
    try {
        const res = await axios.get(API_URL_RESTAURANT_GET_PARAMETRES, { withCredentials: true });

        return res.data as ApiResponse<Parametres[]>;
    } catch (error) {
        console.error(error)
        return false
    }
}

export async function upsertParametres(parametres: Parametres) {
    try {
        const res = await axios.post(
            API_URL_RESTAURANT_UPSERT_PARAMETRES,
            {
                parametres: {
                    id: parametres.id,
                    key: parametres.key,
                    value: parametres.value
                }
            },
            { withCredentials: true });

        return res.data as ApiResponse<{id: number}>;
    } catch(error){
        console.error(error)
        return false
    }
}



